import React from "react";
import { Redirect, Switch, useLocation } from "react-router-dom";

import PageLayout from "../components/Layout/PageLayout";
import RiderSearch from "../views/Rider/RiderSearch";
import ManageBonus from "../views/Rider/Modals/ManageBonus";

import AddPass from "../views/Rider/Modals/AddPass";
import ManagePass from "../views/Rider/Modals/ManagePass";
import CashOut from "../views/Rider/Modals/CashOut";
import CreditWallet from "../views/Rider/Modals/CreditWallet";
import RiderProfile from "../views/Rider/RiderProfile";
import PermissionedRoute from "./PermissionedRoute";
import Permissions from "../permissions";
import ManageAccount from "../views/Rider/Modals/ManageAccount";
import ManageDevices from "../views/Rider/Modals/ManageDevices";
import { accessTokenCookieKey, getCookies, refreshTokenCookieKey } from "../API/cookies";
import IssueFine from "../views/Rider/Modals/IssueFine";

export const RiderRouter = () => {
  const location = useLocation();
  const background = location?.state?.background || location;

  if (!getCookies(accessTokenCookieKey) && !getCookies(refreshTokenCookieKey))
    return <Redirect to={{ pathname: "/logout", state: { from: location.pathname } }} />;
  return (
    <>
      <Switch location={background || location}>
        <PermissionedRoute permission={Permissions.readRidersAdmin} exact path="/riders">
          <PageLayout>
            <RiderSearch />
          </PageLayout>
        </PermissionedRoute>
        <PermissionedRoute permission={Permissions.readRidersAdmin} path="/riders/:riderId">
          <PageLayout>
            <RiderProfile />
          </PageLayout>
        </PermissionedRoute>
      </Switch>
      {/* modals */}
      {background && (
        <Switch>
          <PermissionedRoute
            permission={[Permissions.readWallet, Permissions.writeWallet]}
            path="/riders/:riderId/wallet/bonus"
          >
            <ManageBonus />
          </PermissionedRoute>
          <PermissionedRoute
            permission={Permissions.writeRidersAdmin}
            path="/riders/:riderId/account/manage"
          >
            <ManageAccount />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[
              Permissions.readPasses,
              Permissions.readPassOffers,
              Permissions.readPassOfferTypes,
              Permissions.writePasses,
            ]}
            path="/riders/:riderId/wallet/add-pass"
          >
            <AddPass />
          </PermissionedRoute>
          <PermissionedRoute path="/riders/:riderId/manage-devices">
            <ManageDevices />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[Permissions.readWallet, Permissions.cashoutWallet]}
            path="/riders/:riderId/wallet/transactions/:transactionId/cash-out"
          >
            <CashOut />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[Permissions.readWallet, Permissions.writeWallet]}
            path="/riders/:riderId/reservations/:reservationId/credit-wallet"
          >
            <CreditWallet />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[Permissions.readWallet, Permissions.writeWallet]}
            path="/riders/:riderId/group-reservations/:groupReservationId/credit-wallet"
          >
            <CreditWallet />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[
              Permissions.readPasses,
              Permissions.readPassOffers,
              Permissions.readPassOfferTypes,
              Permissions.writePasses,
            ]}
            path="/riders/:riderId/wallet/manage-pass"
          >
            <ManagePass />
          </PermissionedRoute>
          <PermissionedRoute
            permission={[Permissions.issueFine]}
            path="/riders/:riderId/reservations/:reservationId/issue-fine"
          >
            <IssueFine />
          </PermissionedRoute>
        </Switch>
      )}
    </>
  );
};

export default RiderRouter;
